import { useEffect, useMemo, useState } from "react";
import "./AllPlans.scss";
import { useSelector } from "react-redux";
import newRequest from "../../../utils/newRequest";
import { ScaleLoader } from "react-spinners";
import { IoClose, IoAdd, IoCloseSharp } from "react-icons/io5";
import { FiSearch } from "react-icons/fi";
import { MdDelete, MdEdit, MdAdd } from "react-icons/md";
import { motion } from "framer-motion";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch";
import { showToast } from "../../../toastService";
import Select from "react-select";
import { qilloIconMap, qilloIconOptions } from "../../../utils/iconMapping";
import { customSelectStyles_dark, customSelectStyles_light, muiSelectStyles_dark, muiSelectStyles_light } from "../../../components/ui/CustomSelect";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TablePagination,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Select as MuiSelect,
    MenuItem,
} from "@mui/material";
import { ImHome } from "react-icons/im";
import numeral from "numeral";
import { useTranslation } from "react-i18next";

const AllPlans = () => {
    const { t } = useTranslation();
    const { currentTheme } = useSelector((state) => state.theme);
    const { currentUser } = useSelector((state) => state.user);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [plans, setPlans] = useState([]);
    const [currentAction, setCurrentAction] = useState(null);
    const [isKeyDialogOpened, setIsKeyDialogOpened] = useState(false);


    // plan fields
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [planCode, setPlanCode] = useState(null);
    const [planCodeName, setPlanName] = useState(null);
    const [planEnabled, setPlanEnabled] = useState(null);
    const [categories, setCategories] = useState([]);


    // category fields
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isCategoryDialogOpened, setIsCategoryDialogOpened] = useState(false);
    const [searchPlanCategory, setSearchPlanCategory] = useState("");
    const [serviceCategory, setServiceCategory] = useState(null);
    const [serviceCategoryName, setServiceCategoryName] = useState(null);
    const [serviceCategoryIcon, setServiceCategoryIcon] = useState(null);
    const [selectedIcon, setSelectedIcon] = useState(null);

    // parameters
    const [isParamDialogOpened, setIsParamDialogOpened] = useState(false);
    const [paramOrder, setParamOrder] = useState(1);
    const [paramTitle, setParamTitle] = useState(null);
    const [paramKey, setParamKey] = useState(null);
    const [paramIcon, setParamIcon] = useState(null);
    const [paramDesc, setParamDesc] = useState(null);
    const [paramDataType, setParamDataType] = useState(null);
    const [paramFieldType, setParamFieldType] = useState(null);
    const [paramSchemaName, setParamSchemaName] = useState(null);
    const [paramSchemaFields, setParamSchemaFields] = useState(null);
    const [paramSearchFields, setParamSearchFields] = useState(null);
    const [paramOrderby, setParamOrderby] = useState("");
    const [paramEnabled, setParamEnabled] = useState("Y");
    const [paramFixedList, setParamFixedList] = useState(null);
    const [paramDefaultValue, setParamDefaultValue] = useState("");
    const [selectedParamIcon, setSelectedParamIcon] = useState(null);
    const [services, setServices] = useState([]);
    const [selectedService, setSelectedService] = useState(null);

    const [rowsPerPage, setRowsPerPage] = useState(8);
    const [currentPage, setCurrentPage] = useState(0);
    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 8));
        setCurrentPage(0);
    };


    const fetchPlans = async (firstTime = false) => {
        try {
            if (firstTime) {
                setIsLoading(true);
            } else {
                setIsProcessing(true);
            }
            // Simulate delay for 5 seconds
            // await new Promise((resolve) => setTimeout(resolve, 5000));
            const res = await newRequest.post("/plans/getPlansGrouped", { result_limit: 20 });
            setPlans(res.data);
            // console.log(`setPlans ${JSON.stringify(res.data, null, 2)}`);
            if (res.data) {
                // setSelectedCategory(res.data[0]);
                setSelectedPlan(res.data[0]);
                setPlanCode(res.data[0]?.plan_code);
                setPlanName(res.data[0]?.plan_name);
                setPlanEnabled(res.data[0]?.plan_enabled);
                setCategories(res.data[0]?.categories);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            if (firstTime) {
                setIsLoading(false);
            } else {
                setIsProcessing(false);
            }
        }
    };

    const handleSearchKeys = async () => {
        try {
            setIsProcessing(true);
            if (searchTerm) {
                const res = await newRequest.post("/reportGroup/search", { search_input: searchTerm });
                setPlans(res.data);
                setSelectedCategory(res.data[0]);
                setPlanCode(res.data[0]?.rep_key);
                setPlanName(res.data[0]?.rep_key_name);
                setPlanEnabled(res.data[0]?.rep_enabled);
                setCategories(res.data[0]?.rep_reports);
            } else {
                fetchPlans();
            }
        } catch (error) {
            console.error("Error searching data:", error);
        } finally {
            setIsProcessing(false);
        }
    };

    const handleKeySubmit = async () => {
        try {
            if (currentAction === "editKey") {
                const res = await newRequest.put(`/reportGroup/upd/${selectedCategory?._id}`,
                    {
                        rep_key: planCode,
                        rep_key_name: planCodeName,
                        rep_enabled: planEnabled
                    });

                if (res.status === 200) {
                    const updatedData = [...plans];
                    const index = updatedData.findIndex(rkey => rkey?._id === selectedCategory?._id);
                    if (index !== -1) {
                        updatedData[index]["rep_key"] = planCode;
                        updatedData[index]["rep_key_name"] = planCodeName;
                        updatedData[index]["rep_enabled"] = planEnabled;
                        setPlans(updatedData);
                    }
                    setIsKeyDialogOpened(false);
                    showToast("Updated!", "success");
                } else {
                    setIsKeyDialogOpened(false);
                    showToast(res.data, "error");
                }
            } else if (currentAction === "addKey") {
                const res = await newRequest.post("/reportGroup/add",
                    {
                        rep_key: planCode,
                        rep_key_name: planCodeName,
                        rep_enabled: "Y",
                        rep_reports: []
                    });
                if (res.data === "exists") {
                    showToast("Report key exists", "error");
                } else {
                    await fetchPlans();
                    setIsKeyDialogOpened(false);
                    showToast("Added!", "success");
                }
            }
        } catch (error) {
            console.error("Error searching data:", error);
        }
    };

    const handleReportSubmit = async () => {
        try {
            if (currentAction === "editCategory") {
                const res = await newRequest.post("/reportGroup/updateReport",
                    {
                        plan_docid: selectedPlan?._id,
                        category_code: selectedCategory?._id,
                        service_category: "",

                    });

                // console.log(`updateReport ${JSON.stringify(res.data, null, 2)}`);

                if (res.data?.msg === "updated") {
                    const updatedReport = res.data?.report;
                    // console.log(`updatedReport ${JSON.stringify(updatedReport, null, 2)}`);
                    setCategories((prevReports) => {
                        return prevReports.map((report) =>
                            report?._id === updatedReport?._id ? updatedReport : report
                        );
                    });
                    setIsCategoryDialogOpened(false);
                    showToast("Updated!", "success");
                } else {
                    showToast("Error updating report!", "error");
                }
            } else if (currentAction === "addReport") {
                const res = await newRequest.post("/reportGroup/addReport",
                    {
                        rep_key: selectedCategory?.rep_key,
                        service_category: "",
                        report_icon: selectedIcon?.value,
                    });
                if (res.data?.msg === "added") {
                    setCategories((prevCatg) => [...prevCatg, res.data?.doc]);
                    setIsCategoryDialogOpened(false);
                    showToast("Added!", "success");
                } else {
                    showToast("Error adding report!", "error");
                }
            }
        } catch (error) {
            console.error("Error searching data:", error);
        }
    };

    const handleParameterSubmit = async () => {
        try {

            if (!paramTitle) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please enter prompt!`);
                setIsNotifyDialogOpen(true);
                return;
            }

            if (!paramKey) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please enter key!`);
                setIsNotifyDialogOpen(true);
                return;
            }

            if (!paramDataType) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select data type!`);
                setIsNotifyDialogOpen(true);
                return;
            }

            if (!paramFieldType) {
                setNotifyDialogTitle("Note!");
                setNotifyDialogText(`Please select field type!`);
                setIsNotifyDialogOpen(true);
                return;
            } else {
                if (paramFieldType === "lov") {

                    if (!paramSchemaName) {
                        setNotifyDialogTitle("Note!");
                        setNotifyDialogText(`Please specify schema!`);
                        setIsNotifyDialogOpen(true);
                        return;
                    }

                    if (!paramSchemaFields) {
                        setNotifyDialogTitle("Note!");
                        setNotifyDialogText(`Please specify schema fields!`);
                        setIsNotifyDialogOpen(true);
                        return;
                    }

                    if (!paramSearchFields) {
                        setNotifyDialogTitle("Note!");
                        setNotifyDialogText(`Please specify filter!`);
                        setIsNotifyDialogOpen(true);
                        return;
                    }

                    if (!paramOrderby) {
                        setNotifyDialogTitle("Note!");
                        setNotifyDialogText(`Please specify order by!`);
                        setIsNotifyDialogOpen(true);
                        return;
                    }
                }
            }

            if (currentAction === "addParameter") {
                const res = await newRequest.post("/reportGroup/addReportParameter",
                    {
                        plan_docid: selectedPlan?._id,
                        category_code: selectedCategory?._id,
                        param_title: paramTitle,
                        param_key: paramKey,
                        param_icon: paramIcon,
                        param_desc: paramDesc,
                        param_data_type: paramDataType,
                        param_field_type: paramFieldType,
                        param_fixed_list: paramFixedList,
                        param_default_value: paramDefaultValue,
                        param_schema_name: paramSchemaName?.value,
                        param_schema_fields: paramSchemaFields,
                        param_search_fields: paramSearchFields,
                    });
                if (res.data?.msg === "added") {
                    setServices((prevParams) => [...prevParams, res.data?.parameter]);
                    setIsParamDialogOpened(false);
                    showToast("Added!", "success");
                } else {
                    showToast("Error adding report!", "error");
                }
            } else if (currentAction === "editService") {
                const res = await newRequest.post("/reportGroup/updateReportParameter",
                    {
                        plan_docid: selectedPlan?._id,
                        category_code: selectedCategory?._id,
                        parameter_docid: selectedService?._id,
                        param_order: paramOrder,
                        param_title: paramTitle,
                        param_key: paramKey,
                        param_icon: paramIcon,
                        param_desc: paramDesc,
                        param_data_type: paramDataType,
                        param_field_type: paramFieldType,
                        param_fixed_list: paramFixedList,
                        param_default_value: paramDefaultValue,
                        param_schema_name: paramSchemaName?.value,
                        param_schema_fields: paramSchemaFields,
                        param_enabled: paramEnabled,
                        param_search_fields: paramSearchFields,
                    });

                // console.log(`updateReport ${JSON.stringify(res.data, null, 2)}`);

                if (res.data?.msg === "updated") {
                    const updatedParam = res.data?.parameter;
                    // console.log(`updatedReport ${JSON.stringify(updatedReport, null, 2)}`);
                    setServices((prevParams) => {
                        return prevParams.map((report) =>
                            report?._id === updatedParam?._id ? updatedParam : report
                        );
                    });
                    setIsParamDialogOpened(false);
                    showToast("Updated!", "success");
                } else {
                    showToast("Error updating report!", "error");
                }
            }
        } catch (error) {
            console.error("Error searching data:", error);
        }
    };


    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "deleteCategory") {
                const res = await newRequest.post("/reportGroup/removeReport",
                    {
                        plan_docid: selectedPlan?._id,
                        category_code: selectedCategory?._id
                    });

                // console.log(`removeReport  ${JSON.stringify(res.data, null, 2)}`);

                if (res.data?.msg === "removed") {
                    // Remove from state without re-querying the database
                    setCategories((prevReports) =>
                        prevReports.filter(report => report?._id !== res.data.category_code)
                    );
                    setSelectedCategory(null);
                    showToast("Deleted!", "success");
                } else {
                    showToast("Error deleting report!", "error");
                }
            } else if (confirmDialogAction === "deleteParameter") {
                const res = await newRequest.post("/reportGroup/removeReportParameter",
                    {
                        plan_docid: selectedPlan?._id,
                        category_code: selectedCategory?._id,
                        parameter_docid: selectedService?._id,
                    });

                // console.log(`removeReport  ${JSON.stringify(res.data, null, 2)}`);

                if (res.data?.msg === "removed") {
                    // Remove from state without re-querying the database
                    setServices((prevParams) =>
                        prevParams.filter(param => param?._id !== res.data.parameter_docid)
                    );
                    setSelectedCategory(null);
                    showToast("Deleted!", "success");
                } else {
                    showToast("Error deleting report!", "error");
                }
            }
        } catch (err) {
            console.log(err);
        }
        // Close the dialog
        setIsConfirmDialogOpen(false);
    };


    const filteredCategories = useMemo(() => {
        return categories?.filter(
            (item) =>
                item.service_category?.toLowerCase().includes(searchPlanCategory.toLowerCase()) ||
                item.service_category_name?.toLowerCase().includes(searchPlanCategory.toLowerCase())
        );
    }, [categories, searchPlanCategory]); // Ensure `categories` is a dependency

    const slicedServices = services?.slice(
        currentPage * rowsPerPage,
        currentPage * rowsPerPage + rowsPerPage
    );

    useEffect(() => {
        setServices([]);
        setServices(selectedCategory?.services);
    }, [selectedCategory]);

    useEffect(() => {
        fetchPlans(true);
    }, []);

    return (
        <div className='all-plans'>
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
                        color="var(--primary)"
                        height={50}
                        radius={8}
                        width={4}
                    />
                </div>
            ) : (
                <motion.div
                    className="all-plans-main-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    <div className="all-plans-center-wrapper">
                        <div className="center-navbar">
                            <div className="navbar-left">
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "3px" }}>
                                    <h1 className="main-title"> {planCodeName}</h1>
                                    <span className="sub-title soft boldsmall">{planCode}</span>
                                </div>
                                <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={() => {
                                        try {
                                            setPlanCode(selectedCategory?.rep_key);
                                            setPlanName(selectedCategory?.rep_key_name);
                                            setPlanEnabled(selectedCategory?.rep_enabled);
                                            setCurrentAction("editKey");
                                            setIsKeyDialogOpened(true);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }} icon={<MdEdit />} width={"35px"} height={"35px"} />
                            </div>
                            <div className="navbar-right">
                                {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                    <CustomLoadingButton
                                        currentTheme={currentTheme}
                                        iconPosition="end"
                                        endIcon={<IoAdd />}
                                        onClick={() => {
                                            try {
                                                setCurrentAction("addKey");
                                                setPlanCode(null);
                                                setPlanName(null);
                                                setPlanEnabled("Y");
                                                setCategories([]);
                                                setIsKeyDialogOpened(true);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        {t('addCategory').toUpperCase()}
                                    </CustomLoadingButton>}
                            </div>
                        </div>
                        <div className="center-content">
                            <div className="search-input-wrapper" style={{ width: "40%" }}>
                                <FiSearch className="search-input-icon" />
                                <input
                                    className="search-input"
                                    type="text"
                                    placeholder="Search category..."
                                    value={searchPlanCategory}
                                    onChange={(e) => setSearchPlanCategory(e.target.value)}
                                />
                                {searchPlanCategory.length > 0 && (
                                    <IoCloseSharp
                                        onClick={() => setSearchPlanCategory("")}
                                        className="search-input-icon"
                                    />
                                )}
                                {searchPlanCategory.length === 0 && (
                                    <span className="search-input-icon" />
                                )}
                            </div>
                            {categories?.length > 0 &&
                                <div className="categories-wrapper">
                                    {filteredCategories?.map((catg) => {
                                        const IconComponent = qilloIconMap[catg?.sys_flex01] || ImHome;
                                        return (
                                            <div key={catg?.service_category}
                                                className={`${selectedCategory?.service_category === catg?.service_category ? "sub-menu-item current" : "sub-menu-item"}`}
                                                onClick={async () => {
                                                    try {
                                                        setSelectedCategory(catg);
                                                        setCurrentPage(0);
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}>
                                                <IconComponent className="sub-menu-icon" />
                                                <div className="sub-menu-content">
                                                    <div className="sub-menu-name">{catg?.service_category_name}</div>
                                                    <div className="sub-menu-description">{catg?.service_category}</div>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                                                    <CircularButton
                                                        currentTheme={currentTheme}
                                                        onClick={(e) => {
                                                            try {
                                                                e.stopPropagation();
                                                                setSelectedCategory(catg);
                                                                setCurrentAction("editCategory");
                                                                setServiceCategory(catg?.service_category);
                                                                setServiceCategoryName(catg?.service_category_name);
                                                                setServiceCategoryIcon(catg?.sys_flex01);
                                                                setSelectedIcon({
                                                                    value: catg?.sys_flex01,
                                                                    label:
                                                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                            <IconComponent className="icon" /> {catg?.sys_flex01}
                                                                        </div>
                                                                })
                                                                setIsCategoryDialogOpened(true);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }} icon={<MdEdit color="green" />} width={"35px"} height={"35px"} />
                                                    <CircularButton
                                                        currentTheme={currentTheme}
                                                        onClick={(e) => {
                                                            try {
                                                                e.stopPropagation();
                                                                setSelectedCategory(catg);
                                                                setConfirmationActiontext(`Do you want to delete ${catg?.service_category_name}?`);
                                                                setConfirmDialogAction("deleteCategory");
                                                                setIsConfirmDialogOpen(true);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }} color="#E53935" icon={<MdDelete/>} width={"35px"} height={"35px"} />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>}
                            <hr className="separator-h" />
                            <div className="parameters-wrapper">
                                <div className="parameters-toolbar">
                                    <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                                        {selectedCategory?.service_category_name && <h2 className="main-title">{`${selectedCategory?.service_category_name?.toUpperCase()} ITEMS`}</h2>}
                                        {selectedCategory?.service_category_name &&
                                            ["admin", "superadmin"].includes(currentUser.user_type_xx)
                                            &&
                                            <CircularButton
                                                currentTheme={currentTheme}
                                                onClick={() => {
                                                    try {
                                                        if (!selectedCategory) {
                                                            setNotifyDialogTitle("Note!");
                                                            setNotifyDialogText(`Select category!`);
                                                            setIsNotifyDialogOpen(true);
                                                            return;
                                                        } else {
                                                            setCurrentAction("addParameter");
                                                            setIsParamDialogOpened(true);
                                                        }
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }} icon={<MdAdd />} width={"35px"} height={"35px"} />
                                        }
                                    </div>
                                    {services?.length > rowsPerPage &&
                                        <TablePagination
                                            rowsPerPageOptions={[8]}
                                            rowsPerPage={rowsPerPage}
                                            onRowsPerPageChange={handleRowsPerPage}
                                            component="div"
                                            count={services?.length}
                                            rows={services}
                                            page={currentPage}
                                            onPageChange={handlePageChange}
                                        />}
                                </div>
                                <div className="parameters-content">
                                    <div className="table-content">
                                        <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                            <Table sx={{ width: "max-content", border: 'none' }}>
                                                <TableHead className="tablehead">
                                                    <TableRow className="tablerow">
                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                            #
                                                        </TableCell>
                                                        <TableCell className="table-cell left" style={{ width: "auto" }}>
                                                            <span>{t('service').toUpperCase()}</span>
                                                        </TableCell>
                                                        <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                            <span>{`LIMIT ${currentUser?.currency_code_xx}`}</span>
                                                        </TableCell>
                                                        <TableCell className="table-cell center" style={{ maxWidth: "200px" }}>
                                                            <span>{t('rule').toUpperCase()}</span>
                                                        </TableCell>
                                                        {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                                                <span>{t('action').toUpperCase()}</span>
                                                            </TableCell>}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody className="tablebody">
                                                    {slicedServices?.map((row, index) => {
                                                        // const IconComponent = reportsIconMap[row?.service_icon] || Home;
                                                        return (
                                                            <TableRow
                                                                key={row?._id}
                                                                className={`${selectedService?._id === row?._id ? "tablerow current" : "tablerow"}`}
                                                                onClick={() => setSelectedService(row)}
                                                            >
                                                                <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                                    {index + 1}
                                                                </TableCell>
                                                                <TableCell className="table-cell" style={{ width: "auto" }}>
                                                                    <div style={{ display: "flex", width: "100%", gap: "5px", flexDirection: "column" }}>
                                                                        <h1 className="sub-title">{row.service_title}</h1>
                                                                        <div style={{ display: "flex", width: "100%", gap: "5px", flexDirection: "row" }}>
                                                                            <h1 className="sub-title soft xrsmall">{`REF : ${row.service_ref}`}</h1>
                                                                            {row.service_complexity !== "Normal" && <h1 className="sub-title soft xrsmall">{`Complexity :${row.service_complexity}`}</h1>}
                                                                            {row.service_speciality !== "General" && <h1 className="sub-title soft xrsmall">{`Speciality :${row.service_speciality}`}</h1>}
                                                                        </div>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                                    <h1 className="sub-title">{numeral(row.service_limit).format("0,0.00")}</h1>
                                                                </TableCell>
                                                                <TableCell className="table-cell center" style={{ maxWidth: "200px" }}>
                                                                    <div style={{ display: "flex", width: "100%", gap: "5px", flexDirection: "column", justifyContent: "center" }}>
                                                                        <h1 className="sub-title">{row.service_rule}</h1>
                                                                        <div style={{ display: "flex", width: "100%", gap: "5px", flexDirection: "row", justifyContent: "center" }}>
                                                                            <h1 className="sub-title soft xrsmall">{`Applicable ${row.service_genders.join()}`}</h1>
                                                                        </div>
                                                                    </div>
                                                                </TableCell>
                                                                {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                                                                    <TableCell className="table-cell" style={{ display: 'flex', flexDirection: "row", alignItems: "center", justifyContent: 'space-around', padding: "3px", maxWidth: "100px", }}>
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={(e) => {
                                                                                try {
                                                                                    e.stopPropagation();
                                                                                    setSelectedService(row);
                                                                                    setCurrentAction("editService");

                                                                                    // setParamOrder(row?.param_order);
                                                                                    // setParamTitle(row?.param_title);
                                                                                    // setParamKey(row?.param_key);
                                                                                    // setParamIcon(row?.param_icon);
                                                                                    // setParamDesc(row?.param_desc);
                                                                                    // setParamDataType(row?.param_data_type);
                                                                                    // setParamFieldType(row?.param_field_type);
                                                                                    // setParamSchemaName({
                                                                                    //     value: row?.param_schema_name,
                                                                                    //     label: row?.param_schema_name,
                                                                                    // });
                                                                                    // setParamSchemaFields(row?.param_schema_fields);
                                                                                    // setParamSearchFields(row?.param_search_fields);
                                                                                    // setParamOrderby(row?.param_orderby);
                                                                                    // setParamFixedList(row?.param_fixed_list);
                                                                                    // setParamDefaultValue(row?.param_default_value);
                                                                                    // setSelectedParamIcon({
                                                                                    //     value: row?.param_icon,
                                                                                    //     label:
                                                                                    //         <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                                                    //             <IconComponent className="icon" /> {row?.param_icon}
                                                                                    //         </div>
                                                                                    // });
                                                                                    // setParamEnabled(row?.param_enabled);
                                                                                    // setIsParamDialogOpened(true);
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }} icon={<MdEdit color="green" />} width={"35px"} height={"35px"} />
                                                                        <CircularButton
                                                                            currentTheme={currentTheme}
                                                                            onClick={(e) => {
                                                                                try {
                                                                                    e.stopPropagation();
                                                                                    setSelectedService(row);
                                                                                    setConfirmationActiontext(`Do you want to delete ${row?.param_title}?`);
                                                                                    setConfirmDialogAction("deleteParameter");
                                                                                    setIsConfirmDialogOpen(true);
                                                                                } catch (error) {
                                                                                    console.log(error);
                                                                                }
                                                                            }} color="#E53935" icon={<MdDelete/>} width={"35px"} height={"35px"} />
                                                                    </TableCell>}
                                                            </TableRow>
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="all-plans-right-wrapper">
                        <div className="search-input-wrapper" style={{ width: "95%" }}>
                            <FiSearch className="search-input-icon" />
                            <input
                                className="search-input"
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') handleSearchKeys();
                                }}
                            />
                            {searchTerm.length > 0 && (
                                <IoClose
                                    onClick={async () => {
                                        try {
                                            await fetchPlans();
                                            setSearchTerm("");
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                    className="search-input-icon"
                                />
                            )}
                        </div>
                        <div className="options-list">
                            {plans?.map((plan) => (
                                <>
                                    <span
                                        key={plan?._id}
                                        className={`${selectedPlan?._id === plan?._id
                                            ? "single-option active"
                                            : "single-option"
                                            }`}
                                        onClick={async () => {
                                            try {
                                                setSelectedPlan(plan);
                                                setPlanCode(plan?.plan_code);
                                                setPlanName(plan?.plan_name);
                                                setPlanEnabled(plan?.plan_enabled);
                                                setCategories(plan?.categories);
                                                setSelectedCategory(plan?.categories[0]);
                                                setCurrentPage(0);
                                            } catch (error) {
                                                console.log(error);
                                            }
                                        }}
                                    >
                                        <span className="cy-title">{plan.plan_name}</span>
                                        <span className="cy-type">{plan.plan_code}</span>
                                    </span>
                                    <hr className="separator-h" />
                                </>
                            ))}
                        </div>
                    </div>
                </motion.div>
            )}
            {isKeyDialogOpened && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{`${currentAction === "addKey" ? "ADD KEY" : "EDIT KEY"
                                }`}</h1>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                    try {
                                        setIsKeyDialogOpened(false);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="newName"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    {t('name').toUpperCase()}
                                </label>
                                <input
                                    id="newName"
                                    name="newName"
                                    type="text"
                                    placeholder="NAME"
                                    value={planCodeName}
                                    className="form-input-item"
                                    style={{ width: "350px" }}
                                    onChange={(e) => setPlanName(e.target.value)}
                                />
                            </div>
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="newKey"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    KEY
                                </label>
                                <input
                                    id="newKey"
                                    name="newKey"
                                    type="text"
                                    placeholder="KEY"
                                    value={planCode}
                                    className="form-input-item"
                                    style={{ width: "250px" }}
                                    onChange={(e) => setPlanCode(e.target.value)}
                                    disabled={currentAction !== "addKey"}
                                />
                            </div>
                            <div className="input-item-with-label">
                                <label htmlFor="rep_enabled"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                />
                                <ToggleSwitch
                                    id="rep_enabled"
                                    value={planEnabled}
                                    onChange={setPlanEnabled}
                                    label={"ENABLED"}
                                    labelWidth="max-content"
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                    border="N"
                                    style={{
                                        width: "max-content",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="overlay-actions">
                            <CustomLoadingButton onClick={handleKeySubmit}>
                                {currentAction === "addKey" ? "Add" : "Update"}
                            </CustomLoadingButton>
                        </div>
                    </div>
                </motion.div>
            )}
            {isCategoryDialogOpened && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{`${currentAction === "addReport" ? "ADD REPORT" : "EDIT REPORT"
                                }`}</h1>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                    try {
                                        setIsCategoryDialogOpened(false);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="service_category_name"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    NAME
                                </label>
                                <input
                                    id="service_category_name"
                                    name="service_category_name"
                                    type="text"
                                    placeholder="NAME"
                                    value={serviceCategoryName}
                                    className="form-input-item"
                                    style={{ width: "350px" }}
                                    onChange={(e) => setServiceCategoryName(e.target.value)}
                                />
                            </div>



                            <div className="input-item-with-label">
                                <label
                                    htmlFor="icon_select"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    ICON
                                </label>
                                <Select
                                    id="icon_select"
                                    name="icon_select"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    options={qilloIconOptions}
                                    style={{ width: "350px" }}
                                    isSearchable={true}
                                    placeholder="Select an Icon"
                                    value={selectedIcon}
                                    onChange={setSelectedIcon}
                                    getOptionLabel={(e) => (
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            {e.icon} {e.label}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        <div className="overlay-actions">
                            <CustomLoadingButton onClick={handleReportSubmit}>
                                {currentAction === "addReport" ? "Add" : "Update"}
                            </CustomLoadingButton>
                        </div>
                    </div>
                </motion.div>
            )}

            {/* parameters */}
            {isParamDialogOpened && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{`${currentAction === "addParameter" ? "ADD PARAMETER" : "EDIT PARAMETER"
                                }`}</h1>
                            <CircularButton
                                currentTheme={currentTheme}
                                onClick={() => {
                                    try {
                                        setIsParamDialogOpened(false);
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="paramTitle"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    PROMPT
                                </label>
                                <input
                                    id="paramTitle"
                                    name="paramTitle"
                                    type="text"
                                    placeholder="PROMPT"
                                    value={paramTitle}
                                    className="form-input-item"
                                    style={{ width: "350px" }}
                                    onChange={(e) => setParamTitle(e.target.value)}
                                />

                            </div>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                                <div className="input-item-with-label">
                                    <label
                                        htmlFor="paramKey"
                                        className="form-dropdown-label"
                                        style={{ width: "100px" }}
                                    >
                                        KEY
                                    </label>
                                    <input
                                        id="paramKey"
                                        name="paramKey"
                                        type="text"
                                        placeholder="KEY"
                                        value={paramKey}
                                        className="form-input-item"
                                        style={{ width: "170px" }}
                                        onChange={(e) => setParamKey(e.target.value)}
                                    />
                                </div>
                                <div className="input-item-with-label">
                                    <label
                                        htmlFor="paramOrder"
                                        className="form-dropdown-label"
                                        style={{ width: "max-content" }}
                                    >
                                        ORDER
                                    </label>
                                    <input
                                        id="paramOrder"
                                        name="paramOrder"
                                        type="text"
                                        placeholder="ORDER"
                                        value={paramOrder}
                                        className="form-input-item"
                                        style={{ width: "100px" }}
                                        onChange={(e) => setParamOrder(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="paramIcon"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    ICON
                                </label>
                                <Select
                                    id="paramIcon"
                                    name="paramIcon"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    options={qilloIconOptions}
                                    style={{ width: "350px" }}
                                    isSearchable={true}
                                    placeholder="Select an Icon"
                                    value={selectedParamIcon}
                                    onChange={setSelectedParamIcon}
                                    getOptionLabel={(e) => (
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            {e.icon} {e.label}
                                        </div>
                                    )}
                                />
                            </div>
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="paramDesc"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    DESC
                                </label>
                                <textarea
                                    id="paramDesc"
                                    name="paramDesc"
                                    type="text"
                                    placeholder="NAME"
                                    value={paramDesc}
                                    rows={2}
                                    className="form-input-item"
                                    style={{ width: "350px", height: "max-content" }}
                                    onChange={(e) => setParamDesc(e.target.value)}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", gap: "5px" }}>
                                <div className="input-item-with-label">
                                    <label
                                        htmlFor="paramDataType"
                                        className="form-dropdown-label"
                                        style={{ width: "100px" }}
                                    >
                                        DATA TYPE
                                    </label>
                                    <MuiSelect
                                        id="paramDataType"
                                        name="paramDataType"
                                        variant="outlined"
                                        size="small"
                                        style={{ width: "120px" }}
                                        value={paramDataType}
                                        onChange={(e) => {
                                            setParamDataType(e.target.value);
                                        }}
                                        sx={currentTheme === "dark" ? muiSelectStyles_dark().select : muiSelectStyles_light().select}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: currentTheme === "dark" ? muiSelectStyles_dark().menu.paper : muiSelectStyles_light().menu.paper
                                            }
                                        }}
                                    >
                                        <MenuItem value="number" sx={{ height: '45px' }}>Number</MenuItem>
                                        <MenuItem value="date" sx={{ height: '45px' }}>Date</MenuItem>
                                        <MenuItem value="text" sx={{ height: '45px' }}>Text</MenuItem>
                                    </MuiSelect>
                                </div>
                                <div className="input-item-with-label">
                                    <label
                                        htmlFor="paramFieldType"
                                        className="form-dropdown-label"
                                        style={{ width: "max-content" }}
                                    >
                                        FIELD TYPE
                                    </label>
                                    <MuiSelect
                                        id="paramFieldType"
                                        name="paramFieldType"
                                        variant="outlined"
                                        size="small"
                                        style={{ width: "120px" }}
                                        value={paramFieldType}
                                        onChange={(e) => {
                                            setParamFieldType(e.target.value);
                                        }}
                                        sx={currentTheme === "dark" ? muiSelectStyles_dark().select : muiSelectStyles_light().select}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: currentTheme === "dark" ? muiSelectStyles_dark().menu.paper : muiSelectStyles_light().menu.paper
                                            }
                                        }}
                                    >
                                        <MenuItem value="fixed value" sx={{ height: '45px' }}>Fixed value</MenuItem>
                                        <MenuItem value="fixed list" sx={{ height: '45px' }}>Fixed list</MenuItem>
                                        <MenuItem value="lov" sx={{ height: '45px' }}>LOV</MenuItem>
                                    </MuiSelect>
                                </div>
                            </div>
                            {/* <div className="input-item-with-label">
                                <label
                                    htmlFor="paramSchemaName"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    SCHEMA
                                </label>
                                <Select
                                    id="paramSchemaName"
                                    name="paramSchemaName"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999,
                                        })
                                    }}
                                    width="350px"
                                    value={paramSchemaName}
                                    onChange={(selectedOption) => {
                                        try {
                                            setParamSchemaName(selectedOption);
                                        } catch (error) {
                                            console.log(error);
                                        }
                                    }}
                                    options={schemas}
                                    isSearchable={true}
                                    placeholder="Schema"
                                />
                            </div> */}
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="paramSchemaFields"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    RETURN FIELDS
                                </label>
                                <input
                                    id="paramSchemaFields"
                                    name="paramSchemaFields"
                                    type="text"
                                    placeholder="RETURN FIELDS"
                                    value={paramSchemaFields}
                                    className="form-input-item"
                                    style={{ width: "350px" }}
                                    onChange={(e) => setParamSchemaFields(e.target.value)}
                                />
                            </div>

                            <div className="input-item-with-label">
                                <label
                                    htmlFor="paramSearchFields"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    SEARCH WITH
                                </label>
                                <input
                                    id="paramSearchFields"
                                    name="paramSearchFields"
                                    type="text"
                                    placeholder="SEARCH WITH"
                                    value={paramSearchFields}
                                    className="form-input-item"
                                    style={{ width: "350px" }}
                                    onChange={(e) => setParamSearchFields(e.target.value)}
                                />
                            </div>
                            <div className="input-item-with-label">
                                <label
                                    htmlFor="paramOrderby"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                >
                                    ORDER BY
                                </label>
                                <input
                                    id="paramOrderby"
                                    name="paramOrderby"
                                    type="text"
                                    placeholder="ORDER BY"
                                    value={paramOrderby}
                                    className="form-input-item"
                                    style={{ width: "350px" }}
                                    onChange={(e) => setParamOrderby(e.target.value)}
                                />
                            </div>
                            <div className="input-item-with-label">
                                <label htmlFor="paramEnabled"
                                    className="form-dropdown-label"
                                    style={{ width: "100px" }}
                                />
                                <ToggleSwitch
                                    id="paramEnabled"
                                    value={paramEnabled}
                                    onChange={setParamEnabled}
                                    label={"ENABLED"}
                                    labelWidth="max-content"
                                    disabled={!["admin", "superadmin"].includes(currentUser.user_type_xx)}
                                    border="N"
                                    style={{
                                        width: "max-content",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="overlay-actions">
                            <CustomLoadingButton onClick={handleParameterSubmit}>
                                {currentAction === "addParameter" ? "Add" : "Update"}
                            </CustomLoadingButton>
                        </div>
                    </div>
                </motion.div>
            )}

            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}>Close</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle="Confirmation"
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
        </div>
    )
}



export default AllPlans;